import { render, staticRenderFns } from "./faultReporting.vue?vue&type=template&id=39a5a782&scoped=true&"
import script from "./faultReporting.vue?vue&type=script&lang=js&"
export * from "./faultReporting.vue?vue&type=script&lang=js&"
import style0 from "./faultReporting.vue?vue&type=style&index=0&id=39a5a782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5a782",
  null
  
)

export default component.exports